import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { LOCALE } from "../../utils/locale";
import { BACKDROP_WRAPPER, LOADING_WRAPPER } from "../styles";

export const Spinner = ({ ...props }) => {
  return (
    <Backdrop open={true} {...props} sx={BACKDROP_WRAPPER}>
      <Box sx={LOADING_WRAPPER}>
        <CircularProgress color="inherit" />
        <Typography color={"inherit"} variant="subtitle1">
          {LOCALE.loadingData}
        </Typography>
      </Box>
    </Backdrop>
  );
};
